<template>
  <div class="watchdog" />
</template>

<script lang="ts" setup>
import {
  guardNames,
  type IAppRouteMeta,
  navigationNames,
} from '@booking-portal/router/router-constants';
import { useAuthStore } from '@booking-portal/stores/auth-store';
import { watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

watchEffect(() => {
  const meta: IAppRouteMeta = route.meta as IAppRouteMeta;
  if ((meta.middleware || []).includes(guardNames.authenticatedGuard)) {
    if (authStore.isLoggedOut) {
      router.push({ name: navigationNames.login });
    }
  }
});
</script>

<style scoped lang="scss"></style>
